<template lang="html">
	<div :class='`VueForm ${componentParams.template}`'>
		<!-- {{componentParams}} -->

		<default
			v-if='componentParams.template == "default" || !componentParams.template'
			:data='api_response'
			@SENDFORM='submit'
		/>

		<template v-else>
			Unknown form template <b>{{componentParams.template}}</b>
		</template>
	</div>
</template>

<script>
const objectMerge = require('object-merge');

module.exports = {
	name: 'Form',

	components: {
		'default': require('./forms/default.vue')
	},

	props: {
		dataParams: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			api_response: {}
		}
	},

	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		}
	},

	methods: {
		submit(payload) {
			// console.log(payload);

			let _this = this;

			let method = this.componentParams.method;
			let url = this.componentParams.url;
			let custom_request = objectMerge(this.componentParams.request, payload.request || {});

			let options = {
				responseType: 'json'
			}

			let requestBody = objectMerge(custom_request, payload);

			if(method.toLowerCase() == 'post') {
				// options.params = requestBody;
				// options.body = requestBody;
				options.emulateJSON = true;
				this.$http[method](url, requestBody, options).then(success).catch(error);
			}
			else if(method.toLowerCase() == 'get') {
				options.params = requestBody;
				this.$http[method](url, options).then(success).catch(error);
			}

			function success(response) {
				this.api_response = response.body.api_response;
				// _this.$emit('Update-api-response', response.body.api_response);
				if(response.body.api_response.server_response) {
					if(response.body.api_response.server_response.status == "success") {
						// console.log("success");
						if(response.body.api_response.server_response.showMessage == true){
							$.fancybox.open(response.body.api_response.message, {
								padding: 0,
								afterClose: () => {
									this.$emit('clear');
								}
							});
							document.querySelector('.form-submit').classList.remove('load');
							setTimeout(() => {
								$.fancybox.close()
							}, 4000)
						}

					}
					else {
						console.log('error');
						console.log(response.body.api_response.server_response);
					}
					if(response.body.api_response.server_response.redirect){
						// console.log("redirect");
						console.log(response.body.api_response.server_response.redirect);
						document.location.href = `${response.body.api_response.server_response.redirect}`;
					}
				}
				else {
					$.fancybox.open(response.body.api_response.message, {
						padding: 0,
						afterClose: () => {
							this.$emit('clear');
						}
					});
					document.querySelector('.form-submit').classList.remove('load');
					setTimeout(() => {
						$.fancybox.close()
					}, 4000)
				}
			}

			function error(err) {
				console.log(err);
			}

		}
	},


	beforeMount() {
		let method = this.componentParams.method;
		let url = this.componentParams.url;
		let custom_request = this.componentParams.request;

		let options = {
			responseType: 'json'
		}

		if(method.toLowerCase() == 'post') {
			options.emulateJSON = true;
			this.$http[method](url, custom_request, options).then(success).catch(error);
		}
		else if(method.toLowerCase() == 'get') {
			options.params = custom_request;
			this.$http[method](url, options).then(success).catch(error);
		}

		function success(response) {
			this.api_response = response.body.api_response;
		}

		function error(err) {
			console.log(err);
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Form.vue?40aa6e5c